import { Outlet, useLocation } from "react-router";

import Navigationbar from "./Navigationbar";
import { MenuInfo } from "data";
import { translateCommentLanguage } from "data/data";
import { useTranslation } from "react-i18next";

const MoniteringWrap = ({className1, className2, fullpath, t}) => {
    const monitoring = MenuInfo.CMMS;
    
    return (
        <div className={`monitering${className1}`}>
        {/* <div className={`monitering`}> */}
            <Navigationbar />
            <div className="mobile_navi" style={{color : `${className2}`}}>
                {
                    translateCommentLanguage(((monitoring.children.find((child) => child.isActive) && monitoring.children.find((child) => child.isActive).fullpath === fullpath) ? monitoring.children.find((child) => child.isActive).element?.props?.comment : ""),t)
                }
            </div>
            <Outlet/>
        </div>
    );
}

export default function MonitoringLayout() {
    const { t } = useTranslation();

    const fullpath = useLocation().pathname;
    const className1 = "";
    const className2 = "#FFF";
    
    return (
        <MoniteringWrap className1={className1} className2={className2} fullpath={fullpath} t={t} />
    );
}
